var settings = {};

settings.modes = {
  'relativeTime': {
    text: lang.relativeTimes,
    default: false
  },
  'convertLocalTimes': {
    text: lang.localTimes,
    default: true
  },
  'qrMode': {
    text: lang.quickReply,
    default: false
  },
  'previewOnHover': {
    text: lang.previewOnHover,
    default: false
  },
  'previewOnHoverSound': {
    text: lang.previewOnHoverSound,
    default: false
  },
  'scrollDownMode': {
    text: lang.scrollDownAfterPost,
    default: true
  },
  'sfwMode': {
    text: lang.sfwMode,
    default: false
  },
  'scrollPostFormMode': {
    text: lang.scrollToPostformAfterQuote,
    default: true
  },
  'autoRefreshMode': {
    text: lang.autoReload,
    default: true
  },
  'showYous': {
    text: lang.showYous,
    default: false
  },
  'postCounter': {
    text: lang.postCounter,
    default: false
  },
  'autoMarkAsDeleted': {
    text: lang.autoMarkAsDeleted,
    default: true
  },
  'compressClipboardImages': {
    text: lang.compressClipboardImages,
    default: false
  },
  'autoPlayAnimations': {
    text: lang.autoplayAnimations,
    default: false
  },
  'editInOekaki': {
    text: lang.editInOekaki,
    default: false
  },
  'audioThread': {
    text: lang.audioThread,
    default: false
  },
  'audioThreadAutoPlay': {
    text: lang.audioThreadAutoPlay,
    default: true
  },
  'audioThreadNavPlayer': {
    text: lang.audioThreadNav,
    default: false
  },
  'ensureBypass': {
    text: lang.alwaysUseBypass,
    default: false
  },
  'mediaHiding': {
    text: lang.mediaHiding,
    default: false
  },
  'noWs': {
    text: lang.noWs,
    default: false
  },
  'showHiddenPosts': {
    // Staff-only visibility override for excluded posts (preHide.js).
    // The menu entry is hidden from non-staff AND preHide ignores this flag
    // unless staffNavRole === 'staff' — a regular user setting it by hand
    // changes nothing.
    text: lang.seeHiddenPosts,
    default: false
  },
  'verboseDate': {
    // Literal string for now (2026-08-18 operator call); migrate to a lang.*
    // key if de/ru coverage is ever wanted — an undefined lang key = blank label.
    text: 'Verbose post date',
    default: false
  }
};

settings.init = function() {

};

settings.get = function(key) {

  if (localStorage[key] !== undefined) {

    return JSON.parse(localStorage[key]);

  } else {

    return settings.modes[key].default;

  }

};

settings.set = function(key, value) {

  localStorage.setItem(key, value);

};

settings.init();
